module.exports = __webpack_public_path__ + "static/media/Partly_Safe.86df901e.gif";